class RichtextVideoPlayer {
  constructor() {
    this.init();
  }

  init() {
    const videoContainers = document.querySelectorAll('.richtext-swiper .swiper-slide');
    videoContainers.forEach(container => this.setupContainer(container));
  }

  setupContainer(container) {
    const btn = container.querySelector('.video-play-btn');
    const video = container.querySelector('.video-container');

    if (!btn || !video) return;

    btn.addEventListener('click', () => this.playVideo(video, btn));
  }

  playVideo(video, btn) {
    video.currentTime = 0;
    video.muted = false;
    video.volume = 1;
    video.controls = true;
    video.play();

    btn.classList.add('hide-this');
  }
}

new RichtextVideoPlayer();
